// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"6867f8c0","50":"8fbfd3d4","66":"1973450a","81":"7247258d","154":"d32f28b4","259":"71a74155","391":"81e7082c","619":"1f075130","845":"9e4d2eca","972":"6553a045"}[chunkId] + ".chunk.js";
};